import React from 'react';

const MoonIcon = ({ size, color = "currentColor", ...props }) => (
 <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M1.52232 9.31497C1.79232 13.1775 5.06982 16.32 8.99232 16.4925C11.7598 16.6125 14.2348 15.3225 15.7198 13.29C16.3348 12.4575 16.0048 11.9025 14.9773 12.09C14.4748 12.18 13.9573 12.2175 13.4173 12.195C9.74982 12.045 6.74982 8.97747 6.73482 5.35497C6.72732 4.37997 6.92982 3.45747 7.29732 2.61747C7.70232 1.68747 7.21482 1.24497 6.27732 1.64247C3.30732 2.89497 1.27482 5.88747 1.52232 9.31497Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

);


export default MoonIcon;
